import { createSelector } from 'reselect';
import { getAllSureMotorClaim } from './index';
import { AMC_REQUIRED_DOCUMENTS, FILE_ICONS } from '../../actions/allSureMotorClaim/types';

export const getUploadDocuments = createSelector(
    getAllSureMotorClaim,
    (allSureMotorClaim) => allSureMotorClaim.uploadDocuments
);
export const getPreviouslySelectedCategory = createSelector(
    getUploadDocuments,
    (uploadDocuments) => uploadDocuments.category
);
export const getUploadDocumentForm = createSelector(getUploadDocuments, (uploadDocuments) => uploadDocuments.form);

export const getMaxDocumentLimitReached = createSelector(getUploadDocumentForm, (uploadDocumentsForm) => Object.keys(uploadDocumentsForm).filter(key=>key.startsWith('additionalDocument')).length===4);

export const getDocumentsRequired = createSelector(getUploadDocumentForm, (uploadDocumentsForm) => {
    return Object.keys(uploadDocumentsForm).map((document) => {
        const documentNameKey = document.split('_')[0];
        const imageExtention = uploadDocumentsForm[document].fileName?.split('.')?.slice(-1)[0]?.toLowerCase() ?? null;
        return {
            ...AMC_REQUIRED_DOCUMENTS[documentNameKey],
            key: document,
            imageUrl: FILE_ICONS[imageExtention],
        };
    });
});

export const getDocumentsArray = createSelector(getUploadDocumentForm, (uploadDocuments) => {
    return Object.values(uploadDocuments);
});

export const getSubmittedAndRequiredDocs = createSelector(getUploadDocumentForm, (uploadDocuments) => {
    const submittedDocuments = [];
    const requiredDocuments = [];
    Object.keys(uploadDocuments).map((document) => {
        if(AMC_REQUIRED_DOCUMENTS[document] && !['fireReport','technicalReport'].includes(document)){
            uploadDocuments[document].file 
            ? submittedDocuments.push(AMC_REQUIRED_DOCUMENTS[document].title)
            : requiredDocuments.push(AMC_REQUIRED_DOCUMENTS[document].title);
        } 
        
    });
    return {
        submittedDocuments,
        requiredDocuments,
    };
});
